import styled from "styled-components";

export const AlgorithmsView = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f0f0ff;
  height: 100%;
  width: 100%;
  .file-selected {
    background-color: #f0f0ff;
    flex: 1;
    justify-content: center;
    justify-items: center;
    overflow: auto;
    .header {
      display: flex;
      justify-content: space-between;
      padding: 20px;
      width: 100%;
      box-sizing: border-box;
      &__close {
        background-color: #3e3da3;
        width: 40px;
        height: 40px;
        border-radius: 27.5px;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-size: 14px;
      }
      &__info {
        display: flex;
      }
      &__img {
        margin-right: 10px;
      }
      &__text {
        color: #68688d;
        align-items: center;
      }
    }
  }
  .files {
    overflow: auto;
    height: calc(100% - 80px);
    place-items: center;
  }
  .file {
    border-radius: 14px;
    width: 80%;
    height: 80%;
    overflow: hidden;
    margin-bottom: 10px;
    .file__preview {
      /* width: 100%;
      height: 100%; */
      height: calc(100% - 63px);
      background-color: #fff;
      color: #707582;
      display: flex;
    }
    .file__icon {
      margin: auto;
      font-size: 172px;
    }
    .file__img {
      width: 100%;
      height: 100%;
      border: 2px solid #ffffff7d;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .file__title {
      padding: 16px 10px;
      color: #1f1f52;
      font-size: 17px;
      background-color: #f2f2f7;
      border-bottom: 8px solid #ffffff7d;
      border-right: 8px solid #ffffff7d;
      border-left: 8px solid #ffffff7d;
    }
  }
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 10px;
    padding: 0 20px;
    height: 70px;
    box-sizing: border-box;
    background-color: #f9f9fc;
    .rightsideAlgorithms__headerTitle {
      display: flex;
      align-items: center;
      justify-content: center;
      .rightsideAlgorithms__headerIcon {
        background-color: var(--blue-color);
        display: flex;
        align-items: center;
        justify-content: center;
        height: 30px;
        width: 30px;
        border-radius: 10px;
        color: white;
        box-shadow: 0 0 8px #dbdbe3;
      }
      h4 {
        margin-left: 5px;
        color: var(--title-register-color);
        font-family: "Nunito Bold";
        font-size: 15px;
        strong {
          font-family: "Nunito Sans ExtraBold";
        }
      }
    }
  }
  span {
    color: var(--subtitle-color);
    font-size: 0.7rem;
    text-align: center;
    font-weight: 400;
  }
  .chatbot-container {
    flex: 1;
    background-color: #f0f0ff;
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    padding: 10px 15px 10px 40px;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      /* display: none; */
    }
    &::-webkit-scrollbar-track {
      border: solid 10px transparent;

      box-shadow: inset 0 0 10px 10px transparent;
    }
  }
  .messageDisplay__containerFooter {
    background-color: var(--footer-color);
    padding: 15px 0;
    display: flex;
    color: var(--blue-color);
    align-items: center;
    justify-content: space-evenly;
    input {
      border: none;
      border-radius: 20px;
      padding: 10px;
      width: 90%;
      margin: 0 5px 0 5px;
      outline: none;
      ::placeholder {
        color: #e3e3e3;
        font-family: "Nunito";
      }
    }
    button {
      color: var(--blue-color);
      border: none;
      cursor: pointer;
      display: flex;
      i {
        font-size: 25px;
      }
    }
  }

  .chatbot-footer {
    padding: 20px;
  }

  @media only screen and (max-width: 768px) {
    .rightside__containerMsgs {
      padding: 10px 0px 10px 25px;
    }
    .messageDisplay__containerFooter {
      padding: 15px;
    }
  }
`;
